import { KDProfileData } from "./data";
import { getDateString } from "../../../helper_functions/date_time_formats";

export function kdProfileDataFromJson(json) {

  let windDirection;
  switch (json.wind_direction_r) {
  case 0:
    windDirection = "Head Seas";
    break;
  case 1:
    windDirection = "Beam Seas";
    break;
  case 2:
    windDirection = "Following Seas";
    break;
  }

  return new KDProfileData({
    id: json.id,
    vesselId: json.vesselId,
    profileName: json.profileName,
    valuesList: json.valuesList,
    draft: json.draft,
    trim: json.trim,
    windDirection: windDirection,
    lhv: json.lhv,
    trueWind: json.wind,
    fouling: json.fouling,
    minDate: getDateString(json["date_min"]),
    maxDate: getDateString(json["date_max"]),
    useLatestFouling: json.use_latest_fouling === 1,
  });
}
